import { FieldValues, Path, PathValue, useFormContext } from 'react-hook-form';
import { FormComponentProps } from '../types';
import { Title } from './Title';
import { Button } from './Button';

interface FormMultiButtonGroupProps<T> extends FormComponentProps<T> {
  title: string;
  description?: string;
  hideTitle?: boolean;
  mandatory?: boolean;
  options: { title: string; value: PathValue<T, Path<T>> }[];
}

export const FormMultiButtonGroup = <T extends FieldValues>(props: FormMultiButtonGroupProps<T>) => {
  const { watch, setValue, register } = useFormContext<T>();
  const fieldValue = watch(props.name);
  const inputProps = register<Path<T>>(props.name);

  const handleButtonClick = (value: PathValue<T, Path<T>>) => () => {
    if (props.readonly) return;
    setValue(props.name, value, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
  };

  return (
    <div className="mb-5" {...inputProps}>
      <Title text={props.title} className={`mt-7 mb-5 ${props.hideTitle == true ? 'hidden' : ''}`} />
      {props.description && <p className="mb-7 text-sm">{props.description}</p>}
      {props.options.map(({ title, value }, index) => (
        <Button text={title} key={index} primary={value === fieldValue} onClick={handleButtonClick(value)} className="mr-5" />
      ))}
    </div>
  );
};
